if(jQuery('.paragraph--type--accumulation-accordion').length > 0){
    var allPanels = jQuery('.field--name-field-accordion-item .field__item .container-data').hide();
    jQuery('<div/>',{
      class: 'container-image'
    }).appendTo('.paragraph--type--accumulation-accordion');
    jQuery('.field--name-field-accordion-item .field__item:nth-child(1) .container-data').show();
    jQuery('.container-image').html(jQuery('.field--name-field-accordion-item .field__item:nth-child(1) .field--name-field-destacated-image').html())
    jQuery('.field--name-field-accordion-item  .field__item  .field--name-field-title').on('click',function() {
      $this = jQuery(this);      
      $target = $this.siblings('.container-data');
      if(!$target.hasClass('active')){        
        allPanels.removeClass('active').slideUp();
        $target.addClass('active').slideDown();
        jQuery('.paragraph--type--accumulation-accordion .container-image').html($this.siblings('.field--name-field-destacated-image').html()).slideDown()
      }else{
        console.log("isset class active")
        allPanels.removeClass('active').slideUp();
      }     
      return false;
    });  
}
